import { render, staticRenderFns } from "./HomeSalleAdmin.vue?vue&type=template&id=071db5ef"
import script from "./HomeSalleAdmin.vue?vue&type=script&lang=js"
export * from "./HomeSalleAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports